<template>
  <CContainer>
    <CRow class="justify-content-center mt-4">
      <CCol md="12" class="text-start">
        <div class="d-flex align-items-center">
          <h2>Tardy Management</h2>
          <div class="d-flex align-items-center ms-4">
            <span class="fw-bold me-2">Off</span>
            <CFormSwitch
              data-test-id="tardy-switch"
              class="modules-switch mx-1"
              shape="pill"
              :checked="isActive"
              @update:model-value="toggleTardy(isActive)"
            />
            <span class="fw-bold ms-2">On</span>
          </div>
          <HelpCenterButton
            classes="ms-2"
            content-key="module_tardy_management"
          />
        </div>
        <div v-if="isActive">
          <p class="mt-2 text-start">Input tardy incidents by:</p>
          <CCheckBox
            label="Upload CSV file of tardy data"
            v-model="form.usageCSV"
            class="custom-checkbox text-start"
            :custom="true"
            @update:model-value="submit"
          />
          <CCheckBox
            label="Allow Admins to mark TCH passes as LTC/LTS"
            v-model="form.usageEHP"
            class="custom-checkbox text-start"
            :custom="true"
            @update:model-value="submit"
          />
          <p v-if="form.usageEHP" class="mt-3 text-start">
            In addition to Admins:
          </p>
          <CCheckBox
            v-if="form.usageEHP"
            label="Allow all teachers/staff"
            v-model="form.allowTeacherStaff"
            class="custom-checkbox text-start"
            :custom="true"
            @update:model-value="allowTeacherStaff"
          />
          <!-- Do not delete - will be used for Tardy phase 2  !-->
          <!-- <CCheckBox
            v-if="form.usageEHP"
            label="Allow students"
            v-model="form.allowStudents"
            disabled
            class="custom-checkbox text-start"
            :custom="true"
            @update:model-value="allowStudents"
          /> -->
          <CCheckBox
            v-if="form.usageEHP"
            label="Only allow specific teachers/staff"
            v-model="form.allowSelectedUsersOnly"
            class="custom-checkbox text-start"
            :custom="true"
            @update:model-value="allowSelectedUsersOnly"
          />
          <BaseButton
            v-if="form.allowSelectedUsersOnly && form.usageEHP"
            class="mt-2"
            @click="goToSelectAdultsPage"
            rounded
            >Add Adults</BaseButton
          >
          <p class="mt-3 text-start">
            Allow kids to see the consequences ladder?
          </p>

          <CCheckBox
            label="Yes"
            v-model="form.allowStudentsSeeLevel"
            class="custom-checkbox text-start"
            :custom="true"
            @update:model-value="submit"
          />
        </div>
        <CAlert
          v-if="reqResponse.message"
          class="mt-4"
          :color="reqResponse.type"
          :show="!!reqResponse.message"
        >
          {{ reqResponse.message }}
        </CAlert>
      </CCol>
    </CRow>
  </CContainer>
</template>
<script>
import HelpCenterButton from "../../HelpCenterButton"
import BaseButton from "@/v3components/shared/Buttons/BaseButton.vue"
import { mapState, mapGetters } from "vuex"
import _ from "underscore"
export default {
  name: "TardyManagementModuleForm",
  components: { HelpCenterButton, BaseButton },
  data() {
    return {
      isLoading: false,
      form: {
        allowTeacherStaff: false,
        allowSelectedUsersOnly: false,
        allowStudents: false,
        allowStudentsSeeLevel: false,
        usageCSV: false,
        usageEHP: false
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      },
      isActive: false
    }
  },
  computed: {
    ...mapGetters({
      schoolDomains: "schools/schoolDomains",
      currentUser: "authentication/user"
    }),
    ...mapState({
      options: (state) => {
        const index = _.findIndex(state.schools.activeSchoolModules, {
          name: "Tardy Management"
        })
        return index !== -1
          ? JSON.parse(
              state.schools.activeSchoolModules[index].pivot.option_json
            )
          : false
      },
      active: (state) => {
        const index = _.findIndex(state.schools.activeSchoolModules, {
          name: "Tardy Management"
        })
        return index !== -1
          ? Boolean(state.schools.activeSchoolModules[index].pivot.status)
          : false
      }
    })
  },
  mounted() {
    if (this.options) {
      this.setForm()
    }
    this.isActive = this.active
  },
  methods: {
    setForm() {
      this.form.allowTeacherStaff = this.options["allow-teacher-staff"]
      this.form.allowSelectedUsersOnly =
        this.options["allow-selected-users-only"]
      this.form.allowStudents = this.options["allow-students-create"]
      this.form.allowStudentsSeeLevel = this.options["allow-students-see-level"]
      this.form.usageCSV = this.options.usage["via-csv"]
      this.form.usageEHP = this.options.usage["within-ehp"]
    },
    allowTeacherStaff(value) {
      this.form.allowTeacherStaff = value
      if (value == true) {
        this.form.allowSelectedUsersOnly = false
        this.submit()
      } else {
        this.submit()
      }
    },
    allowStudents(value) {
      this.form.allowStudents = value
      if (value == true) {
        this.form.allowSelectedUsersOnly = false
        this.submit()
      } else {
        this.submit()
      }
    },
    allowSelectedUsersOnly(value) {
      this.form.allowSelectedUsersOnly = value
      if (value == true) {
        this.form.allowTeacherStaff = false
        this.form.allowStudents = false
        this.submit()
      } else {
        this.submit()
      }
    },
    submit() {
      this.resetResponseMessages()
      const inputsData = JSON.stringify({
        "allow-teacher-staff": this.form.allowTeacherStaff,
        "allow-selected-users-only": this.form.allowSelectedUsersOnly,
        "allow-students-create": this.form.allowStudents,
        "allow-students-see-level": this.form.allowStudentsSeeLevel,
        usage: {
          "via-csv": this.form.usageCSV,
          "within-ehp": this.form.usageEHP
        }
      })
      this.isLoading = true
      this.$store
        .dispatch("modules/updateTardyModule", { option_json: inputsData })
        .then(() => {
          this.setSuccessResponse("Module updated.")
          this.$store
            .dispatch("schools/getActiveModules", {
              clearCacheEntry: true
            })
            .then(() => {
              this.setForm()
            })
          this.isLoading = false
          setTimeout(() => {
            this.resetResponseMessages()
          }, 850)
        })
        .catch((err) => {
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
          this.isLoading = false
          this.$store
            .dispatch("schools/getActiveModules", {
              clearCacheEntry: true
            })
            .then(() => {
              this.setForm()
            })
        })
    },
    toggleTardy(status) {
      const moduleStatus = status
        ? {
            status: 0
          }
        : {
            status: 1
          }
      this.$store
        .dispatch("modules/toggleModule", { id: 5, moduleStatus })
        .then(() => {
          this.isActive = !this.isActive
          this.$store
            .dispatch("schools/getActiveModules", {
              clearCacheEntry: true
            })
            .then(() => {
              this.getExceededIncidents()
            })
        })
    },
    getExceededIncidents() {
      this.isActive
        ? this.$store.dispatch("exceededIncidents/getExceededIncidents")
        : this.$store.commit("exceededIncidents/SET_EXCEEDED_INCIDENTS", false)
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    },
    goToSelectAdultsPage() {
      this.$router.push("/tardy-management/adults")
    }
  }
}
</script>
